import Ftextarea from './Ftextarea';
export default Ftextarea;



// WEBPACK FOOTER //
// ./src/components/Ftextarea/index.js